import { render, staticRenderFns } from "./PgaCurrencyField.vue?vue&type=template&id=7a47ed65&"
import script from "./PgaCurrencyField.vue?vue&type=script&lang=ts&"
export * from "./PgaCurrencyField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a47ed65')) {
      api.createRecord('7a47ed65', component.options)
    } else {
      api.reload('7a47ed65', component.options)
    }
    module.hot.accept("./PgaCurrencyField.vue?vue&type=template&id=7a47ed65&", function () {
      api.rerender('7a47ed65', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inputs/PgaCurrencyField.vue"
export default component.exports